<mat-tab-group dynamicHeight>

  <mat-tab label="Dashboards" *ngIf="canViewTab1">
    
    <mat-card>
 
      <mat-card-content *ngIf="tenantId != null && tenantId > 0">
    
        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px;">
    
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="canViewComunidades">
            <app-card-comunidades></app-card-comunidades>
          </div>
    
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="canViewResumenSaldo">
            <app-miResumenSaldo></app-miResumenSaldo>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewComunidadSeguros">
            <app-vencimientoSeguros></app-vencimientoSeguros>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewPedidosVencimientos">
            <app-vencimientoPedidos></app-vencimientoPedidos>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewIncidenciasVencimientos">
            <app-vencimientoIncidencias></app-vencimientoIncidencias>
          </div>
          <div fxFlex=50 fxFlex.xs=100 style="max-width: 300px;" class="flex-item" *ngIf="canViewPedidosEstados">
            <app-pedidos-estados></app-pedidos-estados>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewPedidosVencimientosTipoMaterial">
            <app-vencimientoPedidoTipoMaterial></app-vencimientoPedidoTipoMaterial>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 style="max-width: 300px;" class="flex-item" *ngIf="canViewGastosTiposGasto">
            <app-gasto-tipo-gastos></app-gasto-tipo-gastos>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewGastosRankingTiposGasto">
            <app-gastoRankingTiposGasto></app-gastoRankingTiposGasto>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 style="max-width: 300px;" class="flex-item" *ngIf="canViewGastosServicios">
            <app-gasto-servicios></app-gasto-servicios>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewGastosRankingServicios">
            <app-gastoRankingServicios></app-gastoRankingServicios>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewExpensaUf">
            <app-expensasUf></app-expensasUf>
          </div>
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewMisGastosUf">
            <app-misGastos></app-misGastos>
          </div>
    
          <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="canViewMisPagos">
            <app-misPagos></app-misPagos>
          </div>
          <div fxFlex=50 fxFlex.xs=100 style="max-width: 300px;" class="flex-item" *ngIf="canViewMovimientosTiposMovimiento">
            <app-movimiento-tipo-movimientos></app-movimiento-tipo-movimientos>
          </div>
          <div fxFlex=50 fxFlex.xs=100 style="max-width: 300px;" class="flex-item" *ngIf="canViewResumenCaja">
            <app-resumenCaja></app-resumenCaja>
          </div>
    
    
        </div>
    
      </mat-card-content>
    
    </mat-card>

  </mat-tab>

  <!--Dashboard Publicaciones-->
  <mat-tab label="{{'ComunidadPublicacion' | translate}}" *ngIf="canViewTab2">

    <mat-card *ngIf="tenantId != null && tenantId > 0 && canViewPublicaciones">

      <mat-card-content>

        <mat-expansion-panel [expanded]="true" style="margin: 10px 0px;">

          <mat-expansion-panel-header>
            <mat-panel-title>
                <mat-icon style="margin-top: -3px; margin-right: 5px;">article</mat-icon>
                {{'ComunidadPublicacion' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" *ngIf="canViewPublicaciones">
              <app-publicaciones></app-publicaciones>
            </div>
          </div>

        </mat-expansion-panel>


      </mat-card-content>

    </mat-card>

  </mat-tab>

</mat-tab-group>



